import { render, staticRenderFns } from "./FooterImgLinks.vue?vue&type=template&id=0adbe60a&scoped=true"
import script from "./FooterImgLinks.vue?vue&type=script&lang=js"
export * from "./FooterImgLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adbe60a",
  null
  
)

export default component.exports